import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../../utilities/TabGrid";
import {Link} from "react-router-dom";
import {TopButtonAction} from "../../../../../../componentsTopsa/buttons/TopButtons";
import LSService from "../../../../../../utilities/localStorageService/LSService";

export default class SprawdzCennikiPojedyncze extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderPrzekierowanieButton = this.renderPrzekierowanieButton.bind(this)
    }

    renderPrzekierowanieButton(cell, row) {
        return (
            <Link to={'/konfiguracja/zarzadzanie-biletami/ceny-biletow'} target={'_blank'}>
                <TopButtonAction iconType={'fa fa-table'} btnColor={'default'} text={'Zobacz cennik'}
                                 btnSize={'xs'}
                                 onClick={() => {
                                     this.ustawObiektLocalStorageDoPrzekierowania(row)
                                 }}
                />
            </Link>
        )
    }

    ustawObiektLocalStorageDoPrzekierowania(obj) {
        LSService.ustawObiektDoWyszukaniaCennika(obj)
    }

    renderZnizka(cell,row){
        return <span className={'label label-ebus-default'}>{cell}</span>
    }

    renderStatus(cell,row){
        if (cell === 0) {
            // cennik nie jest w pełni uzupełniony

            return <span><i className={'fa fa-times'} style={{color: 'firebrick'}}></i> Cennik nie jest w pełni uzupełniony
            </span>
        }
        else {
            // cennik jest w pełni uzupełniony
            return <span><i className={'fa fa-check'} style={{color: 'forestgreen'}}></i> Cennik jest w pełni uzupełniony</span>
        }
    }

    render() {

        return (
            <div className={'cennikiPojedynczeSprawdzenieKonfiguracji'}>
                    <BootstrapTable data={this.props.cenniki}
                                    hover
                    >
                        <TableHeaderColumn dataField='rodz' isKey hidden={true}>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField='rodz'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           dataFormat={this.renderZnizka}
                        >Rodzaj</TableHeaderColumn>
                        <TableHeaderColumn dataField='data'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                        >Ważny od</TableHeaderColumn>
                        <TableHeaderColumn dataField='status' dataSort
                                           thStyle={tabgrid.tg6} tdStyle={tabgrid.tg6}
                                           dataFormat={this.renderStatus}
                        >Czy uzupełniony?</TableHeaderColumn>
                        <TableHeaderColumn dataField='odcinki'
                                           thStyle={tabgrid.tg10} tdStyle={tabgrid.tg10}
                        >Odcinki bez zdefiniowanych cen</TableHeaderColumn>
                        <TableHeaderColumn dataField='rodz'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           dataFormat={this.renderPrzekierowanieButton}
                        >Zobacz cennik</TableHeaderColumn>
                    </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/sprawdzKonfiguracje/components/componentsCenniki/SprawdzCennikiPojedyncze.js